import {
  Box,
  Button,
  Chip,
  CircularProgress,
  Grid,
  IconButton,
  Pagination,
  TextField,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React, { useEffect, useState, useRef } from "react";
import MiniDrawer from "../../Components/Drawer";
import { toast } from "react-toastify";
import BaseColor from "../../Config/Color";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { useNavigate, Routes, Route } from "react-router-dom";
import CSelect from "../../Components/CSelect";
import {
  Edit,
  Delete,
  ContentCopy as ContentCopyIcon,
  CheckCircle as CheckCircleIcon,
  Add as AddIcon,
} from "@mui/icons-material";
import { FontFamily } from "../../Config/theme";
import CModal from "../../Components/CModal";
import CButton from "../../Components/CButton";
import { downloadOptions } from "../../Config/staticData";
import Papa from "papaparse";
import ExcelJS from "exceljs";
import _, { isArray, isEmpty } from "lodash";
import { saveAs } from "file-saver";
import { createSearchParams, useSearchParams } from "react-router-dom";
import styles from "./styles";
import { getApiData } from "../../Apis/apiHelper";
import BaseSetting from "../../Apis/setting";
import NotificationPage from './Notification/Notification';

// Remove static data
const postTypeData = [
  {
    id: "approved",
    name: "Approved",
  },
  {
    id: "pending",
    name: "Pending",
  },
  {
    id: "rejected",
    name: "Rejected",
  },
];

export default function CompanyUsers() {
  const navigate = useNavigate();
  const classes = styles();
  const searchRef = useRef();
  const dataGridRef = useRef();

  // Data table and pagination
  const [userData, setUserData] = useState([]);
  const [pageLoad, setPageLoad] = useState(false);
  const [pagination, setPagination] = useState({
    totalPage: 1,
    defaultPageSize: 10,
  });
  const [pageNo, setPageNo] = useState(1);
  const [page, setPage] = useState(1);

  //btn loaders
  const [yesBtnLoading, setYesBtnLoading] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const [confirm, setConfirm] = useState(false);

  // download data in various formats
  const [selectFileType, setSelectFileType] = useState("");
  const [dataLoader, setDataLoader] = useState(false);

  // search and sort
  const [searchVal, setSearchVal] = useState("");
  const [searchParams, setSearchParams] = useSearchParams();
  const [copiedStates, setCopiedStates] = useState({});
  const [rowChange, setRowChange] = useState(false);
  const [userStatus, setUserStatus] = useState(
    searchParams.get("status") === "pending"
      ? {
        id: "pending",
        name: "Pending",
      }
      : searchParams.get("status") === "rejected"
        ? {
          id: "rejected",
          name: "Rejected",
        }
        : searchParams.get("status") === "approved"
          ? {
            id: "approved",
            name: "Approved",
          }
          : {
            id: "approved",
            name: "Approved",
          }
  );

  const [subscriptionType, setSubscriptionType] = useState(
    searchParams.get("created_by") === "created_by_admin"
      ? {
        id: "created_by_admin",
        name: "Created by admin",
      }
      : searchParams.get("created_by") === "created_by_user"
        ? {
          id: "created_by_user",
          name: "Created by user",
        }
        : {
          id: "created_by_all",
          name: "Created by all",
        }
  );

  // get values from URL params
  const isPage = searchParams.get("page");
  const initialPage = isPage ? Number(isPage) : 1;
  const search = searchParams.has("search") ? searchParams.get("search") : "";
  const sortVal = searchParams.has("sort") ? searchParams.get("sort") : "";
  const userStatusVal = searchParams.has("status")
    ? searchParams.get("status")
    : userStatus?.id;
  const sortByVal = searchParams.has("sort_by")
    ? searchParams.get("sort_by")
    : "";
  const createdByVal = searchParams.has("created_by")
    ? searchParams.get("created_by")
    : subscriptionType.id;

  const [userIds, setUserIds] = useState([]);

  useEffect(() => {
    setPage(initialPage);
    setSearchVal(search);
    setHeaderParams(
      initialPage,
      search,
      sortVal,
      sortByVal,
      userStatusVal,
    );
    setTimeout(() => {
      setRowChange(true);
    }, 500);
  }, [initialPage, search, sortVal, sortByVal, userStatusVal, createdByVal]);

  // set params to URL
  const setHeaderParams = (
    page,
    search = "",
    sort = "",
    sortBy = "",
    status = "",
  ) => {
    const params = {
      page: page,
    };

    setPageNo(page);
    if (!_.isEmpty(search)) {
      setSearchVal(search?.trim());
    }
    if (!_.isEmpty(search)) {
      params.search = search;
    }
    if (!_.isEmpty(sort)) {
      params.sort = sort;
    }
    if (!_.isEmpty(sortBy)) {
      params.sort_by = sortBy;
    }
    if (!_.isEmpty(status)) {
      params.status = status;
    }

    setSearchParams(createSearchParams(params));
  };

  const [visibleColumns, setVisibleColumns] = useState([
    "Id",
    "First Name",
    "Last Name",
    "Company Name",
    "Website",
    "Email",
    "Landline Number",
    "Zipcode",
    "State",
    "City",
    "Street Name",
    "Created At",
  ]);

  useEffect(() => {
    setPageLoad(true);
    getCompanyUserData(
      page,
      search,
      sortVal,
      sortByVal,
      userStatusVal,
      createdByVal
    );
  }, [userStatus, subscriptionType]);
  // Add an initial data load when component mounts
  useEffect(() => {
    setPageLoad(true);
    getCompanyUserData(
      page,
      search,
      sortVal,
      sortByVal,
      userStatusVal,
      createdByVal
    );
  }, []);

  //get all company user data
  const getCompanyUserData = (
    page,
    search,
    sort,
    sortBy,
    status,
    subscription
  ) => {
    setDataLoader(true);
    setPageLoad(true);

    const data = {
      page: page,
      type: "admin",
    };

    if (!_.isEmpty(search)) {
      data.searchVal = search?.trim();
    }

    if (!_.isEmpty(sort)) {
      data.sort = sort;
    }

    if (!_.isEmpty(sortBy)) {
      data.sort_by = sortBy;
    }

    if (!_.isEmpty(status)) {
      data.status = status;
    }

    if (!_.isEmpty(subscription)) {
      data.created_by = subscription;
    }

    getApiData(BaseSetting.endpoint.allUsersList, "post", data)
      .then((result) => {
        if (result?.status) {
          const response = result?.data;

          setUserData(
            (response?.allUser || []).map((user, idx) => ({
              ...user,
              id: user.id ?? `temp-id-${idx}`, // fallback if id is null/undefined
            }))
          );
          setPagination(response?.pagination);
          setPage(page);
          setTimeout(() => {
            setDataLoader(false);
            setPageLoad(false);
          }, 100);
        } else {
          setUserData([]);
          setPagination({
            totalPage: 1,
            limit: 10,
          });
          setDataLoader(false);
          setPageLoad(false);
        }
      })
      .catch((err) => {
        toast(err?.message, { type: "error" });
        setDataLoader(false);
        setPageLoad(false);
      });
  };

  //delete user
  const deleteUser = () => {
    setYesBtnLoading(true);
    // Simulate API call
    setTimeout(() => {
      toast("User deleted successfully", { type: "success" });
      setYesBtnLoading(false);
      setConfirm(false);
      setDeleteId("");
      getCompanyUserData(
        pageNo,
        search,
        sortVal,
        sortByVal,
        userStatusVal,
        createdByVal
      );
    }, 1000);
  };

  // delete multiple users
  const deleteMultipleUsers = () => {
    setYesBtnLoading(true);
    // Simulate API call
    setTimeout(() => {
      toast("Users deleted successfully", { type: "success" });
      setConfirm(false);
      setYesBtnLoading(false);
      setUserIds([]);
      getCompanyUserData(
        pageNo,
        search,
        sortVal,
        sortByVal,
        userStatusVal,
        createdByVal
      );
    }, 1000);
  };

  const handleCopyClick = (id, companyName) => {
    const company_name = companyName
      .replace(/[^\w-]/g, "-")
      .replace(/-+/g, "-")
      .replace(/^-|-$/g, "")
      .toLowerCase();
    navigator.clipboard.writeText(
      `${BaseSetting.appUrl}/${company_name}-${id}`
    );

    setCopiedStates((prevState) => ({
      ...prevState,
      [id]: true,
    }));
    setTimeout(() => {
      setCopiedStates((prevState) => ({
        ...prevState,
        [id]: false,
      }));
    }, 3000);
  };

  const handleDownloadCSV = async (data) => {
    const csvData = Papa.unparse(data);
    const blob = new Blob([csvData], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `${userStatus.name}-${subscriptionType.name}-Data.csv`;
    link.click();
    URL.revokeObjectURL(url);
    setSelectFileType("");
  };

  const handleDownloadExcel = async (data) => {
    try {
      // Guard for empty data
      if (!data || data.length === 0) {
        console.warn("No data to export");
        return;
      }

      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Sheet1");

      // Create columns dynamically based on object keys
      worksheet.columns = Object.keys(data[0]).map((key) => ({
        header: key,
        key: key,
        width: 20, // optional: set column width
      }));

      // Make header row bold
      worksheet.getRow(1).font = { bold: true };

      // Add all rows
      worksheet.addRows(data);

      // Generate Excel buffer
      const buffer = await workbook.xlsx.writeBuffer();

      // Save the Excel file
      saveAs(
        new Blob([buffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        }),
        `${userStatus.name}-${subscriptionType.name}-Data.xlsx`
      );

      setSelectFileType("");
    } catch (error) {
      console.error("Error:", error);
    }
  };

  //Download data api call
  function getDownloadData(type) {
    const data = {
      download: true,
      type: "admin",
      page: 1,
      download_id: userIds,
    };

    if (!_.isEmpty(userStatusVal)) {
      data.status = userStatusVal;
    }

    if (!_.isEmpty(createdByVal)) {
      data.created_by = createdByVal;
    }

    getApiData(BaseSetting.endpoint.allUsersList, "post", data)
      .then((result) => {
        if (result?.status) {
          const response = result?.data?.allUser;

          let dataSort = [];
          response.map((val, index) => {
            const createdAtTimestamp = new Date(val?.createdAt);
            const options = {
              year: "numeric",
              month: "short",
              day: "numeric",
              hour: "2-digit",
              minute: "2-digit",
            };
            const formattedLoginAt = new Intl.DateTimeFormat(
              "en-US",
              options
            ).format(createdAtTimestamp);

            let newObj = {
              No: index + 1,
              "First name": val?.first_name || "",
              "Last name": val?.last_name || "",
              "Company name": val?.businessInfo?.name || "",
              Website: val?.businessInfo?.website || "",
              "Email": val?.email || "",
              "Landline Number": val?.businessInfo?.landline_number || "",
              Zipcode: val?.businessInfo?.zipcode || "",
              State: val?.businessInfo?.state || "",
              City: val?.businessInfo?.city || "",
              "Street Name": val?.businessInfo?.street_name || "",
              "Created at": formattedLoginAt,
            };
            dataSort.push(newObj);
          });

          if (type === "Download as CSV") {
            handleDownloadCSV(dataSort);
          } else {
            handleDownloadExcel(dataSort);
          }
        } else {
          toast(result?.message, { type: "error" });
        }
      })
      .catch((err) => {
        toast(err?.message, { type: "error" });
      });
  }

  const usersColumns = [
    {
      field: "id",
      headerName: "NO.",
      flex: 0.2,
      minWidth: 70,
      headerAlign: "center",
      align: "center",
      sortable: false,
      renderCell: (params) => {
        const pageSize = pagination?.limit || 10; // Default to 10 if undefined
        const newStartIndex = ((pageNo || 1) - 1) * pageSize + 1;
        const index = userData.findIndex(item => item.id === params.row.id);
        const serialNumber = index + newStartIndex;
        return (
          <Typography style={{ fontFamily: FontFamily.SemiBold }}>
            {serialNumber}
          </Typography>
        );
      },
    },
    {
      field: "actions",
      headerName: "ACTIONS",
      minWidth: 230,
      headerAlign: "center",
      align: "center",
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        console.log(params?.row?.id)
        return (
          <>
            <div>
              <Button
                variant="contained"
                onClick={() =>
                  navigate(
                    `/company-user-detail?id=${params?.row?.id}&page=${page}&search=${search}&sort=${sortVal}&status=${userStatusVal}&sort_by=${sortByVal}&created_by=${createdByVal}`
                  )
                }
              >
                View more
              </Button>
            </div>

            {(userStatusVal == "approved" || userStatusVal == "pending") && (
              <Grid container alignItems={"center"} justifyContent={"center"}>
                <Grid item>
                  <Tooltip title="Edit" placement="top" arrow>
                    <Button
                      onClick={() => {
                        navigate(
                          `/company-user-form?id=${params?.row?.id}&page=${page}&search=${search}&sort=${sortVal}&status=${userStatusVal}&sort_by=${sortByVal}&created_by=${createdByVal}`,
                          {
                            state: {
                              update: true,
                              userId: params?.row?.id,
                            },
                          }
                        );
                      }}
                    >
                      <Edit style={{ fontSize: 20 }} />
                    </Button>
                  </Tooltip>
                </Grid>
                {_.isEmpty(userIds) ? (
                  <Grid item>
                    <Tooltip title="Delete" placement="top" arrow>
                      <Button
                        onClick={() => {
                          setConfirm(true);
                          setDeleteId(params?.row?.id);
                        }}
                      >
                        <Delete
                          style={{ fontSize: 20, color: BaseColor.red }}
                        />
                      </Button>
                    </Tooltip>
                  </Grid>
                ) : (
                  ""
                )}
              </Grid>
            )}
            <Tooltip
              title={
                copiedStates[params?.row?.businessInfo?.id] ? "Copied!" : "Copy to clipboard"
              }
              placement="bottom"
              arrow
            >
              <IconButton
                onClick={() =>
                  handleCopyClick(params?.row?.businessInfo?.id, params?.row?.businessInfo?.name || "company")
                }
                color={copiedStates[params?.row?.businessInfo?.id] ? "success" : "primary"}
              >
                {copiedStates[params?.row?.businessInfo?.id] ? (
                  <CheckCircleIcon />
                ) : (
                  <ContentCopyIcon />
                )}
              </IconButton>
            </Tooltip>
          </>
        );
      },
    },
    {
      field: "first_name",
      headerName: "FIRST NAME",
      width: 150,
      headerAlign: "center",
      align: "center",
      valueGetter: (params) => params.row.first_name || "",
    },
    {
      field: "last_name",
      headerName: "LAST NAME",
      width: 150,
      headerAlign: "center",
      align: "center",
      valueGetter: (params) => params.row.last_name || "",
    },
    {
      field: "company_name",
      headerName: "COMPANY NAME",
      width: 200,
      headerAlign: "center",
      align: "center",
      valueGetter: (params) => {
        const value = params.row.businessInfo?.name;
        return value && value.toString().toLowerCase() !== "null" ? value : "-";
      },
    },
    {
      field: "website",
      headerName: "WEBSITE",
      width: 200,
      headerAlign: "center",
      align: "center",
      valueGetter: (params) => {
        const value = params.row.businessInfo?.website;
        return value && value.toString().toLowerCase() !== "null" ? value : "-";
      },
    },
    {
      field: "email",
      headerName: "EMAIL",
      width: 200,
      headerAlign: "center",
      align: "center",
      valueGetter: (params) => {
        const value = params.row.email;
        return value && value.toString().toLowerCase() !== "null" ? value : "-";
      },
    },
    {
      field: "phone",
      headerName: "PHONE",
      width: 200,
      headerAlign: "center",
      align: "center",
      valueGetter: (params) => {
        const value = params.row.phone;
        return value && value.toString().toLowerCase() !== "null" ? value : "-";
      },
    },
    {
      field: "landline_number",
      headerName: "LANDLINE NUMBER",
      width: 200,
      headerAlign: "center",
      align: "center",
      valueGetter: (params) => {
        const value = params.row.businessInfo?.landline_number;
        return value && value.toString().toLowerCase() !== "null" ? value : "-";
      },
    },
    {
      field: "zipcode",
      headerName: "ZIPCODE",
      width: 150,
      headerAlign: "center",
      align: "center",
      valueGetter: (params) => {
        const value = params.row.businessInfo?.zipcode;
        return value && value.toString().toLowerCase() !== "null" ? value : "-";
      },
    },
    {
      field: "country",
      headerName: "COUNTRY",
      width: 150,
      headerAlign: "center",
      align: "center",
      valueGetter: (params) => {
        const value = params.row?.country;
        return value && value.toString().toLowerCase() !== "null" ? value : "-";
      },
    },
    {
      field: "state",
      headerName: "STATE",
      width: 150,
      headerAlign: "center",
      align: "center",
      valueGetter: (params) => {
        const value = params.row?.businessInfo?.state;
        return value && value.toString().toLowerCase() !== "null" ? value : "-";
      }
    },
    {
      field: "city",
      headerName: "CITY",
      width: 150,
      headerAlign: "center",
      align: "center",
      valueGetter: (params) => {
        const value = params.row?.businessInfo?.city;
        return value && value.toString().toLowerCase() !== "null" ? value : "-";
      }
    },
    {
      field: "street_name",
      headerName: "STREET NAME",
      width: 200,
      headerAlign: "center",
      align: "center",
      valueGetter: (params) => {
        const value = params.row.businessInfo?.street_name;
        return value && value.toString().toLowerCase() !== "null" ? value : "-";
      },
    },
    {
      field: "createdAt",
      headerName: "CREATED AT",
      width: 200,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        const createdAtTimestamp = new Date(params?.row?.createdAt);
        const options = {
          year: "numeric",
          month: "short",
          day: "numeric",
        };
        const formattedCreatedAt = new Intl.DateTimeFormat(
          "en-US",
          options
        ).format(createdAtTimestamp);
        return formattedCreatedAt;
      },
    },
  ];

  const filterColumns = usersColumns.filter((data) => data.hidden !== true);

  return (
    <Grid container>
      <MiniDrawer
        header="Company Users"
        children={
          <>
            <Grid
              container
              alignItems={"center"}
              justifyContent={"space-between"}
              spacing={1}
            >
              <Grid item xs={12} sm={6} md={3}>
                <CSelect
                  fullObj
                  data={postTypeData}
                  placeholder="Select status"
                  value={postTypeData?.find(
                    (data) => data?.id === userStatusVal
                  )}
                  onSelect={(val) => {
                    setUserStatus(val);
                    setUserIds([]);
                    setSearchVal("");
                    setHeaderParams(1, "", "", "", val?.id, createdByVal);
                  }}
                />
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                sx={{
                  display: "flex",
                  justifyContent: { xs: "flex-start", sm: "flex-end" },
                  alignItems: "center",
                  mt: { xs: 2, sm: 0 },
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    flexWrap: "wrap",
                    width: "100%",
                    justifyContent: { xs: "flex-start", sm: "flex-end" },
                  }}
                >
                  {!_.isEmpty(search) ||
                    !_.isEmpty(sortVal) ||
                    !_.isEmpty(sortByVal) ||
                    !_.isEmpty(userIds) ? (
                    <Button
                      variant="contained"
                      onClick={() => {
                        setUserIds([]);
                        setSearchVal("");
                        setHeaderParams(
                          page,
                          "",
                          "",
                          "",
                          userStatusVal,
                          createdByVal
                        );
                        getCompanyUserData(
                          page,
                          "",
                          "",
                          "",
                          userStatusVal,
                          createdByVal
                        );
                        setDataLoader(true);
                        if (dataGridRef.current) {
                          dataGridRef.current.setFilterModel({
                            items: [],
                            quickFilter: "",
                          });
                        }
                      }}
                      sx={{
                        ml: { xs: 0, sm: 1 },
                        mt: { xs: 1, sm: 0 },
                      }}
                    >
                      Clear filters
                    </Button>
                  ) : null}

                  {userStatusVal == "approved" && !_.isEmpty(userIds) ? (
                    <Button
                      variant="outlined"
                      style={{ color: "red", borderColor: "red" }}
                      onClick={() => {
                        setConfirm(true);
                      }}
                      sx={{
                        ml: { xs: 0, sm: 1 },
                        mt: { xs: 1, sm: 0 },
                      }}
                    >
                      Delete
                    </Button>
                  ) : (
                    ""
                  )}
                  <CSelect
                    placeholder="Choose file format for download"
                    value={selectFileType}
                    data={downloadOptions}
                    onSelect={(val) => {
                      setSelectFileType(val);
                      getDownloadData(val);
                    }}
                    sx={{
                      width: { xs: "100%", sm: "auto" },
                      mt: { xs: 1, sm: 0 },
                    }}
                  />
                </Box>
              </Grid>
            </Grid>

            <Grid container mt={"30px"}>
              {pageLoad ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                    height: "50vh",
                  }}
                >
                  <CircularProgress
                    style={{ color: BaseColor.primary }}
                    size={30}
                  />
                </div>
              ) : (
                <DataGrid
                  sortModel={
                    sortByVal === "asc" || sortByVal === "desc"
                      ? [
                        {
                          field: sortVal,
                          sort: sortByVal,
                        },
                      ]
                      : []
                  }
                  onSortModelChange={(model) => {
                    setDataLoader(true);
                    if (!_.isEmpty(model)) {
                      setHeaderParams(
                        page,
                        search,
                        model[0]?.field,
                        model[0].sort,
                        userStatusVal,
                        createdByVal
                      );
                      getCompanyUserData(
                        page,
                        search,
                        model[0]?.field,
                        model[0].sort,
                        userStatusVal,
                        createdByVal
                      );
                    } else {
                      setHeaderParams(
                        page,
                        search,
                        "",
                        "",
                        userStatusVal,
                        createdByVal
                      );
                      getCompanyUserData(
                        page,
                        search,
                        "",
                        "",
                        userStatusVal,
                        createdByVal
                      );
                    }
                  }}
                  disableColumnFilter
                  disableColumnSelector
                  rows={userData}
                  columns={filterColumns}
                  disableColumnMenu
                  disableDensitySelector
                  sortingMode="server"
                  apiRef={(api) => {
                    dataGridRef.current = api;
                  }}
                  loading={dataLoader}
                  hideFooter={isEmpty(userIds)}
                  hideFooterPagination
                  showCellVerticalBorder={true}
                  showColumnVerticalBorder={true}
                  autoHeight={true}
                  getRowHeight={() => "auto"}
                  slots={{ toolbar: GridToolbar }}
                  disableRowSelectionOnClick
                  checkboxSelection
                  rowSelectionModel={userIds}
                  keepNonExistentRowsSelected
                  paginationMode="server"
                  onRowSelectionModelChange={(id) => {
                    setUserIds(id);
                    if (rowChange === true) {
                      setHeaderParams(
                        page,
                        search,
                        sortVal,
                        sortByVal,
                        userStatusVal,
                        createdByVal
                      );
                    }
                  }}
                  initialState={{
                    filter: {
                      filterModel: {
                        items: [],
                        quickFilterValues: [searchVal],
                      },
                    },
                  }}
                  slotProps={{
                    toolbar: {
                      printOptions: { disableToolbarButton: true },
                      csvOptions: { disableToolbarButton: true },
                      showQuickFilter: true,
                      onChange: (e) => {
                        setDataLoader(true);
                        const searchValue = e.target.value?.toLowerCase();
                        setSearchVal(searchValue);
                        setHeaderParams(
                          1,
                          searchValue,
                          sortVal,
                          sortByVal,
                          userStatusVal,
                          createdByVal
                        );
                        if (searchRef.current) clearTimeout(searchRef.current);
                        searchRef.current = setTimeout(() => {
                          getCompanyUserData(
                            1,
                            searchValue,
                            sortVal,
                            sortByVal,
                            userStatusVal,
                            createdByVal
                          );
                        }, 800);
                      },
                    },
                  }}
                />
              )}
            </Grid>
            {!isEmpty(userData) && isArray(userData) && (
              <div
                style={{
                  marginTop: "20px",
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <Pagination
                  count={pagination?.totalPages}
                  page={page}
                  siblingCount={2}
                  onChange={(e, value) => {
                    setPageLoad(true);
                    setPageNo(value);
                    setPage(value);
                    setHeaderParams(
                      value,
                      search,
                      sortVal,
                      sortByVal,
                      userStatusVal,
                      createdByVal
                    );
                    getCompanyUserData(
                      value,
                      search,
                      sortVal,
                      sortByVal,
                      userStatusVal,
                      createdByVal
                    );
                  }}
                  sx={{ display: pageLoad ? "none" : "block" }}
                />
              </div>
            )}
          </>
        }
      />
      <CModal
        visible={confirm}
        title={"Delete user"}
        onClose={() => {
          setConfirm(false);
          setDeleteId("");
        }}
        children={
          <>
            <Grid container padding={"30px 0px"}>
              <Grid item xs={12}>
                <Typography
                  style={{
                    marginBottom: 15,
                    fontFamily: FontFamily.SemiBold,
                    fontSize: 20,
                    textAlign: "center",
                  }}
                >
                  Are you sure you want to delete this user ?
                </Typography>
              </Grid>
              <Grid container justifyContent={"center"} gap={2} wrap="nowrap">
                <Grid item xs={4}>
                  <Button
                    fullWidth
                    variant="outlined"
                    style={{ marginRight: "20px" }}
                    onClick={() => {
                      setConfirm(false);
                      setDeleteId("");
                    }}
                  >
                    No
                  </Button>
                </Grid>
                <Grid item xs={4}>
                  <CButton
                    onClick={() =>
                      !_.isEmpty(userIds) ? deleteMultipleUsers() : deleteUser()
                    }
                    fullWidth
                    variant="contained"
                    loading={yesBtnLoading}
                  >
                    Yes
                  </CButton>
                </Grid>
              </Grid>
            </Grid>
          </>
        }
      />
      <Routes>
        <Route path="notifications" element={<NotificationPage />} />
      </Routes>
    </Grid>
  );
}
